import { call, put, takeLatest } from 'redux-saga/effects';
import { error, request, success } from 'store/api/actions';
import { baseApi } from 'store/api/apiRequestBuilder';
import { ISearchProps } from 'types';
import { camelize, logger } from 'utils';

import { getNewestNfts } from '../actions';
import actionTypes from '../actionTypes';
import { setNewest } from '../reducer';

export function* getNewestNftsSaga({ type }: ReturnType<typeof getNewestNfts>) {
  yield put(request(type));

  try {
    const { data } = yield call(baseApi.searchNfts, {
      props: {
        type: 'items',
        orderBy: '-created_at',
        page: 1,
        itemsPerPage: 12,
      } as ISearchProps,
    });

    yield put(setNewest(camelize(data.results)));

    yield put(success(type));
  } catch (e) {
    yield put(error(type, e));
    logger('getNewestNftsSaga', e);
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_NEWEST, getNewestNftsSaga);
}
